import ControlPanelFilter from "./control-panel-filter";

export default ControlPanelFilter;